module.exports = __webpack_public_path__ + "static/media/thumb.1f517be7.png";